import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScheduleCreationStateButtonsComponent } from './schedule-creation-state-buttons.component';
import { SharedModule } from '../../../../shared/shared.module';
import { MaterialModule } from '../../../../shared/material.module';
import { BackAndForthWarningModule } from '../back-and-forth-warning/back-and-forth-warning.module';
import { MatTooltipModule } from '@angular/material/tooltip';



@NgModule({
  declarations: [
    ScheduleCreationStateButtonsComponent
  ],
  exports: [
    ScheduleCreationStateButtonsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    BackAndForthWarningModule,
    MatTooltipModule
  ]
})
export class ScheduleCreationStateButtonsModule { }
